export class CustomerPropertyCodes {
    static readonly NAME = 'name';
    static readonly CODE = 'code';
    static readonly EMAIL = 'email';
    static readonly SIRET = 'siret';
    static readonly MOBILE_NUMBER = 'mobileNumber';
}
